module.exports = __webpack_public_path__ + "img/tank.cb41ad5c.svg";